import { isFieldEmpty } from "@limitless/common/utils";
import { isEmailValid } from "../../../customer/utils";
import { areFieldsPristine, areAnyFieldsPristine } from "../FieldValidators";

/**
 * Validates the user inputs of the sign in form
 *
 * @param {object} fields
 * @param {string} errorMessage
 * @param {string} redirectMessage
 */
export const validateSignInForm = (fields, errorMessage, redirectMessage, validatePassword) => {
  const fieldErrors = {};
  const userErrorMessage = redirectMessage ? redirectMessage : errorMessage;

  //If the all the fields are pristine, don't show any errors
  if (areFieldsPristine(fields)) {
    return {
      fieldErrors,
      isFormInvalid: true,
      userErrorMessage
    };
  }
  const {
    email,
    password
  } = fields;
  if (!email.pristine && !isEmailValid(email.value)) {
    fieldErrors.email = "Email address is not valid";
  } else if (!email.pristine && isFieldEmpty(email.value)) {
    fieldErrors.email = "Please enter an email address";
  }
  if (validatePassword && !password.pristine && isFieldEmpty(password.value)) {
    fieldErrors.password = "Password invalid";
  }

  //the form is invalid if any field has an error or if there are fields untouched
  const isFormInvalid = Object.keys(fieldErrors).length > 0 || areAnyFieldsPristine(fields);
  return {
    fieldErrors,
    isFormInvalid,
    userErrorMessage
  };
};